///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export const ITEMS_PER_PAGE = 10;
export const DEFAULT_PAGE = 1;
export const DEFAULT_TOTAL_ITEMS = 0;
